module.exports = __webpack_public_path__ + "media/subway/Z-5eb33a03.png";